import { render, staticRenderFns } from "./ElementsFormsInstructions.vue?vue&type=template&id=4c78bff3"
import script from "./ElementsFormsInstructions.vue?vue&type=script&lang=ts"
export * from "./ElementsFormsInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports